var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerRightLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 3,
    viewBox: "0 0 382 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.23828L191 1.2383L382 1.23831",
    stroke: "url(#paint0_linear_250_6523)",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_6523",
    x1: -93.2643,
    y1: 0.738273,
    x2: 382,
    y2: 0.738315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerRightLine);
export default __webpack_public_path__ + "static/media/Divider-right-line.26f2907d12d73e2812af1739fa471a73.svg";
export { ForwardRef as ReactComponent };